export default __webpack_public_path__ + "static/molly-c2548825f48d51a2a053689b1d73672c.png";